var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgİconLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #3a3838;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,0c-2.4,0-4,1.6-4,4v12c0,2.4,1.6,4,4,4s4-1.6,4-4V4c0-2.4-1.6-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,22.8c.8.4,1.2.4,2,.4,1.2,0,2.8-.8,3.6-2l6-10.4c1.2-2,.4-4.4-1.6-5.6-2-1.2-4.4-.4-5.6,1.6l-6,10.4c-.8,2-.4,4.4,1.6,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.2,30c.8,1.2,2,2,3.6,2s1.2,0,2-.4l10.4-6c2-1.2,2.4-3.6,1.6-5.6-1.2-2-3.6-2.4-5.6-1.6l-10.4,6c-2,1.2-2.4,3.6-1.6,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76,36h-12c-2.4,0-4,1.6-4,4s1.6,4,4,4h12c2.4,0,4-1.6,4-4s-1.6-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.2,54.8l-10.4-6c-2-1.2-4.4-.4-5.6,1.6-1.2,2-.4,4.4,1.6,5.6l10.4,6c.8.4,1.2.4,2,.4,1.2,0,2.8-.8,3.6-2,.8-2.4.4-4.8-1.6-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.2,58.8c-1.2-2-3.6-2.4-5.6-1.6-2,1.2-2.4,3.6-1.6,5.6l6,10.4c.8,1.2,2,2,3.6,2s1.2,0,2-.4c2-1.2,2.4-3.6,1.6-5.6l-6-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,60c-2,0-4,1.6-4,4v12c0,2.4,1.6,4,4,4h0c2,0,4-1.6,4-4v-12c0-2-2-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,57.2c-2-1.2-4.4-.4-5.6,1.6l-6,10.4c-1.2,2-.4,4.4,1.6,5.6.8.4,1.2.4,2,.4,1.2,0,2.8-.8,3.6-2l6-10.4c.8-2,.4-4.4-1.6-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.8,50c-1.2-2-3.6-2.4-5.6-1.6l-10.4,6c-2,1.2-2.4,3.6-1.6,5.6.8,1.2,2,2,3.6,2s1.2,0,2-.4l10.4-6c2-1.2,2.4-3.6,1.6-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,44c2,0,4-1.6,4-4s-1.6-4-4-4H4c-2,0-4,1.6-4,4s1.6,4,4,4h12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgİconLoading);
export default __webpack_public_path__ + "static/media/icon_loading.cd2f2b7011e396dbb0711d55247dde15.svg";
export { ForwardRef as ReactComponent };